import { unitAPI } from './api';
import Swal from 'sweetalert2';

export const unitActions = {
    // Fetch all units with filters
    fetchUnits: (filters = {}) => {
        return async (dispatch) => {
            try {
                const response = await unitAPI.list({
                    page: filters.page || 1,
                    limit: filters.limit || 10,
                    search: filters.search || '',
                    status: filters.status || '',
                    date: filters.date || '',
                    sort_by: filters.sort_by || 'created_at',
                    sort_order: filters.sort_order || 'DESC'
                });
                
                if (response.status) {
                    dispatch({
                        type: "Unit_list",
                        payload: response.data.units
                    });
                    
                    return {
                        success: true,
                        data: response.data
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error fetching units:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to fetch units',
                    confirmButtonColor: '#ff0000'
                });
                return {
                    success: false,
                    message: error.message || 'Failed to fetch units'
                };
            }
        };
    },
    
    // Get single unit
    fetchUnitById: (id) => {
        return async () => {
            try {
                const response = await unitAPI.get(id);
                
                if (response.status) {
                    return {
                        success: true,
                        data: response.data
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error fetching unit:', error);
                return {
                    success: false,
                    message: error.message || 'Failed to fetch unit'
                };
            }
        };
    },
    
    // Create unit
    createUnit: (unitData) => {
        return async (dispatch) => {
            try {
                const response = await unitAPI.create(unitData);
                
                if (response.status) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success!',
                        text: 'Unit created successfully',
                        confirmButtonColor: '#00ff00'
                    });
                    
                    // Refresh unit list
                    dispatch(unitActions.fetchUnits());
                    
                    return {
                        success: true,
                        data: response.data
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error creating unit:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: error.message || 'Failed to create unit',
                    confirmButtonColor: '#ff0000'
                });
                return {
                    success: false,
                    message: error.message || 'Failed to create unit'
                };
            }
        };
    },
    
    // Update unit
    updateUnit: (id, unitData) => {
        return async (dispatch) => {
            try {
                const response = await unitAPI.update(id, unitData);
                
                if (response.status) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success!',
                        text: 'Unit updated successfully',
                        confirmButtonColor: '#00ff00'
                    });
                    
                    // Refresh unit list
                    dispatch(unitActions.fetchUnits());
                    
                    return {
                        success: true,
                        data: response.data
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error updating unit:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: error.message || 'Failed to update unit',
                    confirmButtonColor: '#ff0000'
                });
                return {
                    success: false,
                    message: error.message || 'Failed to update unit'
                };
            }
        };
    },
    
    // Delete unit
    deleteUnit: (id) => {
        return async (dispatch) => {
            try {
                const response = await unitAPI.delete(id);
                
                if (response.status) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: 'Unit deleted successfully',
                        confirmButtonColor: '#00ff00'
                    });
                    
                    // Refresh unit list
                    dispatch(unitActions.fetchUnits());
                    
                    return {
                        success: true
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error deleting unit:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: error.message || 'Failed to delete unit',
                    confirmButtonColor: '#ff0000'
                });
                return {
                    success: false,
                    message: error.message || 'Failed to delete unit'
                };
            }
        };
    }
};